import { useContext } from 'react'
import RecordsManagementContext from '../contexts/RecordsManagementContext'

export const useRecordsManagement = () => useContext(RecordsManagementContext)
